import {
  colors,
  spacing,
  fontSizes,
  fonts,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
export const localStyles = stylex.create({
  bottom: {
    display: "flex",
    width: "100%",
    flexDirection: { default: "column", "@media (min-width: 768px)": "row" },
    alignItems: "center",
    justifyContent: {
      default: "normal",
      "@media (min-width: 768px)": "space-between",
    },
    gap: { default: spacing.space24, "@media (min-width: 768px)": 0 },
  },
  brand: {
    display: "flex",
    height: 24,
    width: 200,
    flexShrink: 0,
    alignItems: "center",
    justifyContent: {
      default: "center",
      "@media (min-width: 768px)": "normal",
    },
  },
  brandLink: {
    position: "relative",
    display: "flex",
    alignItems: "flex-end",
    gap: 4.88,
    "::after": {
      content: { default: "none", "@media (pointer: coarse)": '""' },
      position: "absolute",
      insetInline: 0,
      top: "50%",
      height: 44,
      transform: "translateY(-50%)",
    },
  },
  brandmark: { display: "block", height: 14.85, width: 14.54 },
  wordmark: {
    pointerEvents: "none",
    display: "block",
    height: 18.29,
    width: 91.47,
    maxWidth: "none",
    borderRadius: 1.22,
    objectFit: "cover",
  },
  motto: {
    display: "flex",
    flexShrink: 1,
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 0,
    maxWidth: "100%",
    gap: spacing.space4,
    textAlign: "center",
  },
  quote: {
    margin: 0,
    fontFamily: fonts.serif,
    fontSize: fontSizes.label,
    lineHeight: "normal",
    letterSpacing: "0.28px",
    wordBreak: "break-word",
    whiteSpace: "normal",
    color: colors.inverse,
    fontStyle: "italic",
  },
  attribution: {
    display: "flex",
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 2,
  },
  attributionText: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: 12,
    lineHeight: "normal",
    fontWeight: 400,
    letterSpacing: "1.08px",
    wordBreak: "break-word",
    whiteSpace: "nowrap",
    color: colors.inverse,
    textTransform: "uppercase",
  },
});
